/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllLoadingEquipment,
  AddLoadEquipmentDetails,
  UpdateLoadEquipmentDetails,
} from "../../Apis/loadingEquipmentApi";

import {
  GetZone,
  GetCircle,
  GetWard,
  GetCirclebyID,
  GetWardsbyCircleId,
} from "../../Apis/organizationApi";
import { AllShiftMaster } from "../../Apis/shiftMasterApi";
import {
  AllVehicleTypeDetails,
  AllVehicleStatusDetails,
  AllVehicleCapacityDetails,
} from "../../Apis/vehicleApi";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import { AllOwnerTypeDetails } from "../../Apis/ownerTypeApi";

import { AllDriverDetails } from "../../Apis/driverApi";
import { getAllTransferStationMaster } from "../../Apis/transferStationApi";
import { getAllDeploymentInchargeMaster } from "../../Apis/primaryDeploymentInchargeApi";
import { GetAllSecondaryDeploymentInchargeDetails } from "../../Apis/secondaryDeploymentInchargeApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import Loader from "../../Common/Loader/loader";
import ImageCompressor from "image-compressor.js";
import { withTranslation } from "react-i18next";
import Select from "react-select";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { jsPDF } from "jspdf";
import QRCode from "qrcode-svg";
import { useDropdownStore } from "../AssetVehicle/store/useDropdownStore";
import { CorporationStore } from "../corporation_master/CorporationStore";
import TableSkeleton from "../AllotedMaster/TableSkeleton";

const LoadingEquipment = ({ t }) => {
  const headers = [
       "qrCode",
    "loadingEquipmentNumber",
    "loadingEquipmentUid",
    // "vehicleType",
    "ownerType",
    "vehicleStatus",
    "vehicleType",
    "VehicleCapacity",
    "corporation",
    "zone",
    "circle",
    "ward",
    "shiftA", // Added Shift A header
    "shiftB", // Added Shift B header
    "shiftC",
    // "shift",
 
    "loadingEquipmentCode",
    "status",
    "actions",
  ];

  //  console.log("vehicleCapacities",vehicleCapacities)
  const [lgShow, setLgShow] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [vehicleStatusDetails, setVehicleStatusDetails] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [vehicleCapacityDetails, setVehicleCapacityDetails] = useState([]);
  console.log("vehicleCapacityDetails", vehicleCapacityDetails);
  const [collectionTypeDetails, setCollectionTypeDetails] = useState([]);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [editVehicleData, setEditVehicleData] = useState("");
  const { fetchUserCorporations, UserCorporations } = CorporationStore();
  const [selectedCorporationId, setSelectedCorporationId] = useState("");
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [shiftData, setShiftData] = useState([]);
  const [allDriverData, setAllDriverData] = useState([]);
  const [shift, setshift] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [loadingWards, setLoadingWards] = useState(false);
  const [rcImagePreview, setRcImagePreview] = useState(null);
  const [pcImagePreview, setPcImagePreview] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isInputValid, setIsInputValid] = useState(true);
  const [allDeploymentInchargeData, setAllDeploymentInchargeData] = useState(
    []
  );
  const [
    allSecondaryDeploymentInchargeData,
    setAllSecondaryDeploymentInchargeData,
  ] = useState([]);
  const [allTransferStationData, setallTransferStationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [
    filterOriginalLoadingEquipmentData,
    setFilterOriginalLoadingEquipmentData,
  ] = useState([]);
  const [formInput, setFormInput] = useState({
    loadingEquipmentUid: "",
    loadingEquipmentNumber: "",
    // chassisNumber: "",
    vehicleTypeId: "",
    zoneId: "",
    zoneName: "",
    circleName: "",
    circleId: "",
    wardId: null,
    // shiftId:[],
    shiftName: "",
    ownerTypeId: "",
    ownerTypeName: "",
    vehicleCapacityId: "",
    vehicleStatusId: "",
    vehicleStatusName: "",
    // collectionTypeId: "",
    loadingEquipmentCode: "",
    ShiftA: null,
    ShiftB: null,
    ShiftC: null,
    isActive: true,
  });

  const handleClose = () => {
    setFormInput({
      loadingEquipmentUid: "",
      loadingEquipmentNumber: "",
      chassisNumber: "",
      vehicleTypeId: "",
      collectionTypeId: "",
      zoneId: "",
      circleId: "",
      wardId: null,
      shiftId: "",
      ownerTypeId: "",
      ownerTypeName: "",
      vehicleCapacityId: "",
      vehicleStatusName: "",
      isActive: "",
    });
    setEditVehicleData(""); // Reset the editVehicleData state
    setSelectedZone(""); // Reset selected zone
    setSelectedCorporationId(""); // Reset selected corporation
    setAllCircles([]); // Clear circles
    setAllWards([]); // Clear wards
    setLgShow(false);
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      loadingEquipmentUid: "",
      loadingEquipmentNumber: "",
      vehicleTypeId: "",
      ownerTypeName: "",
      zoneId: "",
      circleId: "",
      wardId: null,
      shiftId: "",
      ownerTypeId: "",
      vehicleCapacityId: "",
      vehicleStatusId: "",
      vehicleStatusName: "",
      collectionTypeId: "",
      remarks: "",
      isActive: true,
    });
    setEditVehicleData(null);
    setSelectedZone(""); // Reset selected zone
    setSelectedCorporationId(""); // Reset selected corporation
    setAllCircles([]); // Clear circles
    setAllWards([]); // Clear wards
    setImagePreview(null);
    setRcImagePreview(null); // Reset rc image preview to null
    setPcImagePreview(null);
    setVehicleDetails("");
  };

  // Consolidated function to fetch all initial data once
  const fetchAllInitialData = async () => {
    try {
      setIsLoading(true);
      const [
        vehicleStatusResponse,
        primaryDeploymentInchargeResponse,
        secondaryDeploymentInchargeResponse,
        transferStationData,
        vehicleTypeResponse,
        collectionTypeResponse,
        ownerTypeResponse,
        loadingEquipmentResponse,
      ] = await Promise.all([
        AllVehicleStatusDetails(),
        getAllDeploymentInchargeMaster(),
        GetAllSecondaryDeploymentInchargeDetails(),
        getAllTransferStationMaster(),
        AllVehicleTypeDetails(),
        AllCollectionTypeDetails(),
        AllOwnerTypeDetails(),
        AllLoadingEquipment(),
      ]);

      setVehicleStatusDetails(vehicleStatusResponse);
      setAllDeploymentInchargeData(primaryDeploymentInchargeResponse);
      setAllSecondaryDeploymentInchargeData(secondaryDeploymentInchargeResponse);
      setallTransferStationData(transferStationData);
      setVehicleTypeDetails(vehicleTypeResponse);
      setCollectionTypeDetails(collectionTypeResponse);
      setOwnerTypeDetails(ownerTypeResponse);

      // Process loading equipment data
      const sortedRouteData = loadingEquipmentResponse.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setSortedData(sortedRouteData);
      setVehicleDetails(loadingEquipmentResponse);
      setOriginalData(loadingEquipmentResponse);

      // Process for table display
      const allVehiclesData = loadingEquipmentResponse.map((station) => {
        const vehicleTypeNames = loadingEquipmentResponse.find(
          (vehicle) => vehicle.vehicleTypeId === station.vehicleTypeId
        );

        return {
          ...station,
          loadingEquipmentUID: station.loadingEquipmentUid || "N/A",
          ownerType: station.ownerTypeName || "N/A",
          vehicleTypeName: station.vehicleTypeName || "N/A",
          VehicleCapacity: station.vehicleCapacityName || "N/A",
          vehicleStatus: station.vehicleStatusName || "N/A",
          corporation: station.corporationName || "N/A",
          zone: station.zoneName || "N/A",
          circle: station.circleName || "N/A",
          ward: station.wardName || "N/A",
          shift: station.shiftName || "N/A",
          vehicleType: vehicleTypeNames?.vehicleTypeName || "N/A",
          status: station.isActive ? "Active" : "InActive",
        };
      });

      const sortedVehiclesData = allVehiclesData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setAllVehicleData(sortedVehiclesData);
      setFilterOriginalLoadingEquipmentData(sortedVehiclesData);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllInitialData();
  }, []);

  const fetchShiftDetails = async () => {
    const [shiftDetails] = await Promise.all([AllShiftMaster()]);
    const shiftData = shiftDetails.map((station) => {
      return {
        ...station,
        shift: station.shiftName, // Assuming the API response has a key named shiftName for shift names
        status: station.isActive ? "Active" : "InActive",
      };
    });
    //console.log(shift,'shifts')
    // Sort the data based on the isActive field
    const sortedshiftData = shiftData.sort((a, b) => {
      if (a.isActive === b.isActive) {
        return 0;
      }
      return a.isActive ? -1 : 1;
    });

    setshift(sortedshiftData);
  };

  useEffect(() => {
    // Fetch vehicle capacity details when the component mounts
    const fetchVehicleCapacityDetails = async () => {
      try {
        const vehicleCapacityResponse = await AllVehicleCapacityDetails(); // Fetch vehicle capacity details from the API
        setVehicleCapacityDetails(vehicleCapacityResponse); // Update state with vehicle capacity details
      } catch (error) {
        console.error("Error fetching vehicle capacity details:", error);
      }
    };

    fetchVehicleCapacityDetails(); // Invoke the function to fetch vehicle capacity details
  }, []);

  // Fetch driver details separately (not in the list of APIs to consolidate)
  useEffect(() => {
    const fetchDriverDetails = async () => {
      try {
        const driverData = await AllDriverDetails();
        setAllDriverData(driverData);
      } catch (error) {
        console.error("Error fetching driver details:", error);
      }
    };

    fetchDriverDetails();
  }, []);

  const handleEditVehicleData = async (selectedVehicle) => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 2000);
    setEditVehicleData(selectedVehicle);
    setSelectedZone(selectedVehicle.zoneId); // Set the selected zone ID
    // Set corporation based on the zone data
    const matchedZone = allZones.find((z) => String(z.zoneId) === String(selectedVehicle.zoneId));
    if (matchedZone?.corporationId) {
      setSelectedCorporationId(String(matchedZone.corporationId));
    }

    // Set other form inputs based on the selected vehicle
    setFormInput({
      ...formInput,
      zoneId: selectedVehicle.zoneId,
      circleName: selectedVehicle.circleName,
      wardName: selectedVehicle.wardName,
      zoneName: selectedVehicle.zoneName,
      circleId: selectedVehicle.circleId,
      wardId: selectedVehicle.wardId,
      id: selectedVehicle.id,
      shiftId: selectedVehicle.shiftId,
      ShiftA: selectedVehicle.shiftA,
      ShiftB: selectedVehicle.shiftB,
      ShiftC: selectedVehicle.shiftC,
      loadingEquipmentUid: selectedVehicle.loadingEquipmentUid,
      loadingEquipmentNumber: selectedVehicle.loadingEquipmentNumber,
      // chassisNumber: selectedVehicle.chassisNumber,
      vehicleTypeId: selectedVehicle.vehicleTypeId,
      vehicleCapacityId: selectedVehicle.vehicleCapacityId,
      vehicleTypeName: selectedVehicle.vehicleTypeName,
      ownerTypeId: selectedVehicle.ownerTypeId,

      vehicleStatusId: selectedVehicle.vehicleStatusId,
      vehicleStatusName: selectedVehicle.vehicleStatusName,
      collectionTypeName: selectedVehicle.collectionTypeName,
      ownerTypeName: selectedVehicle.ownerTypeName,
      loadingEquipmentCode: selectedVehicle.loadingEquipmentCode,
      // remarks: selectedVehicle.remarks,
      isActive: selectedVehicle.isActive,
    });
    try {
      // Fetch circles for the selected zone
      const circlesData = await GetCirclebyID(selectedVehicle.zoneId);
      setAllCircles(circlesData);

      // Fetch wards for the selected circle
      const wardsData = await GetWardsbyCircleId(selectedVehicle.circleId);
      setAllWards(wardsData);

      // Ensure that the wardId is set correctly in the formInput state
      // This is crucial for displaying the correct value in the Ward field
      setFormInput((prevData) => ({
        ...prevData,
        wardId: selectedVehicle.wardId, // Make sure to update wardId after fetching the data
      }));
    } catch (error) {
      console.error("Error fetching circles and wards data:", error);
      // Handle errors appropriately
    }

    setLgShow(true); // Show the modal for editing vehicle details
  };

  // Function to refresh only loading equipment data (called after add/update)
  const fetchLoadingEquipmentData = async () => {
    try {
      setIsLoading(true);
      const response = await AllLoadingEquipment();

      const sortedRouteData = response.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setSortedData(sortedRouteData);

      setVehicleDetails(response);
      setOriginalData(response);

      // Process for table display
      const allVehiclesData = response.map((station) => {
        const vehicleTypeNames = response.find(
          (vehicle) => vehicle.vehicleTypeId === station.vehicleTypeId
        );

        return {
          ...station,
          loadingEquipmentUID: station.loadingEquipmentUid || "N/A",
          ownerType: station.ownerTypeName || "N/A",
          vehicleTypeName: station.vehicleTypeName || "N/A",
          VehicleCapacity: station.vehicleCapacityName || "N/A",
          vehicleStatus: station.vehicleStatusName || "N/A",
          corporation: station.corporationName || "N/A",
          zone: station.zoneName || "N/A",
          circle: station.circleName || "N/A",
          ward: station.wardName || "N/A",
          shift: station.shiftName || "N/A",
          vehicleType: vehicleTypeNames?.vehicleTypeName || "N/A",
          status: station.isActive ? "Active" : "InActive",
        };
      });

      const sortedVehiclesData = allVehiclesData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setAllVehicleData(sortedVehiclesData);
      setFilterOriginalLoadingEquipmentData(sortedVehiclesData);
    } catch (error) {
      console.error("Error fetching loading equipment data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchShiftDetails();
  }, []);

  useEffect(() => {
    fetchUserCorporations();
  }, []);

  const handleShiftChange = (selectedOptions) => {
    // const selectedValues = Array.isArray(selectedOptions)
    //   ? selectedOptions.map((option) => option.value).filter(value => value !== undefined)
    //   : selectedOptions
    //   ? [selectedOptions.value]
    //   : [];
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.value)
      : selectedOptions
      ? selectedOptions.value
      : null;

    // Update the form input with the selected values
    setFormInput((prevState) => ({
      ...prevState,
      shiftid: selectedValues,
      isSupervisor: selectedValues.length > 1 ? true : prevState.isSupervisor,
    }));

    if (selectedValues.length === 0 && formSubmitted) {
      setIsInputValid(false);
    } else {
      setIsInputValid(true);
    }
  };

  const optionsofShifts = shift.map((station) => {
    // console.log(station, 'station');
    return {
      value: station.shiftId,
      label: station.shiftName,
    };
  });

  const handleCreateVehicleDetails = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    const requiredFields = [
      "loadingEquipmentNumber",
      "loadingEquipmentUid",
      "loadingEquipmentCode",
      "vehicleTypeId",
      "vehicleCapacityId",
      "ownerTypeId",
      "ownerTypeName",
      "vehicleStatusName",
    ];

    // Validate all required fields
    const missingFields = requiredFields.filter((field) => !formInput[field]);

    if (missingFields.length > 0) {
      console.log("Required fields are missing:", missingFields);
      return; // Avoid calling the API if any required field is missing
    }

    // Check if at least one shift is selected
    if (!formInput.ShiftA && !formInput.ShiftB && !formInput.ShiftC) {
      toast.error("Please select at least one shift (A, B, or C).", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
      });
      return; // Exit the function to prevent API call if no shift is selected
    }

    // Check if shiftId is not selected (empty string)
    const shiftIdToSend = formInput.shiftId === "" ? null : formInput.shiftId;

    // Prepare the vehicle data
    const newVehicleData = {
      loadingEquipmentNumber: formInput.loadingEquipmentNumber,
      loadingEquipmentUid: formInput.loadingEquipmentUid,
      loadingEquipmentCode: formInput.loadingEquipmentCode,
      vehicleTypeId: formInput.vehicleTypeId,
      ownerTypeId: formInput.ownerTypeId,
      circleId: formInput.circleId,
      circleName: formInput.circleName,
      zoneId: formInput.zoneId,
      wardId: formInput.wardId,
      zoneName: formInput.zoneName,
      wardName: formInput.wardName,
      shiftId: shiftIdToSend, // Use shiftIdToSend to handle empty shiftId
      shiftA: formInput.ShiftA,
      shiftB: formInput.ShiftB,
      shiftC: formInput.ShiftC,
      shiftName: formInput.shiftName,
      ownerTypeName: formInput.ownerTypeName,
      vehicleCapacityId: formInput.vehicleCapacityId,
      vehicleStatusId: formInput.vehicleStatusId,
      vehicleStatusName: formInput.vehicleStatusName,
      isActive: formInput.isActive,
      corporationId: selectedCorporationId ? Number(selectedCorporationId) : null,
    };

    try {
      setIsLoading(true);

      if (editVehicleData) {
        const updatedVehicleData = {
          ...newVehicleData,
          shiftId: shiftIdToSend,
          loadingEquipmentId: editVehicleData.loadingEquipmentId,
        };

        await UpdateLoadEquipmentDetails(updatedVehicleData);
        toast.success("Loading Equipment updated successfully");
      } else {
        await AddLoadEquipmentDetails(newVehicleData);
        toast.success("Loading Equipment added successfully");
      }

      // Only call AllLoadingEquipment after add/update
      await fetchLoadingEquipmentData();
      handleClose();
    } catch (error) {
      console.error("Error details:", error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          const validationErrors = data;
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 409) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (editVehicleData) {
      setFormInput((prevData) => ({
        ...prevData,
        ...editVehicleData,
        vehicleImageUrl: null, // Set vehicleImageUrl to null initially
        rcimageUrl: null, // Set rcimageUrl to the existing value or an empty string if not present
        pcimageUrl: null, // Set pcimageUrl to the existing value or an empty string if not present
        // Add other properties from editVehicleData if needed
      }));

      // Update image preview with the URL from editVehicleData
      if (editVehicleData.vehicleImageUrl) {
        const previewURL = editVehicleData.vehicleImageUrl;
        setImagePreview(previewURL);
      } else {
        setImagePreview(null); // Reset image preview if no vehicleImageUrl is present
      }

      // Update rc image preview with the URL from editVehicleData
      if (editVehicleData.rcimageUrl) {
        const rcPreviewURL = editVehicleData.rcimageUrl;
        setRcImagePreview(rcPreviewURL);
      } else {
        setRcImagePreview(null); // Reset rc image preview if no rcimageUrl is present
      }

      // Update pc image preview with the URL from editVehicleData
      if (editVehicleData.pcimageUrl) {
        const pcPreviewURL = editVehicleData.pcimageUrl;
        setPcImagePreview(pcPreviewURL);
      } else {
        setPcImagePreview(null); // Reset pc image preview if no pcimageUrl is present
      }
    } else {
      setFormInput({
        loadingEquipmentUid: "",
        loadingEquipmentNumber: "",
        chassisNumber: "",
        vehicleTypeId: "",
        zoneId: "",
        circleId: "",
        wardId: null,
        shiftId: "",
        ownerTypeId: "",
        driverId: "",
        primaryDeploymentInchargeId: "",
        transferStationId: "",
        secondaryDeploymentInchargeId: "",
        vehicleCapacityId: "",
        vehicleStatusId: "",
        vehicleStatusName: "",
        net_weight: "",
        deployment_location_id: "",
        vehicleImageUrl: "", // Set vehicleImageUrl to null initially
        // collectionTypeId: "",
        status: "",
        loadingEquipmentCode: "",
        // remarks: "",
        pcimageUrl: "",
        rcimageUrl: "",
      });
      setImagePreview(null); // Reset image preview if no editVehicleData
      setRcImagePreview(null); // Reset rc image preview if no editVehicleData
      setPcImagePreview(null); // Reset pc image preview if no editVehicleData
    }
  }, [editVehicleData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Sanitize input based on field name
    switch (name) {
      case "vehicleTypeId":
        // If it's a vehicle type field, set the value and type name in the form input
        const intValue1 = parseInt(value, 10);

        const selectedVehicleType = vehicleTypeDetails.find(
          (type) => type.vehicleTypeId === intValue1
        );

        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue1,
          vehicleTypeName: selectedVehicleType
            ? selectedVehicleType.vehicleTypeName
            : "",
        }));
        break;
      // case "vehicleCapacityId":

      //   const intValue12 = parseInt(value, 10);

      //   const selectedVehicleCapacity = vehicleCapacities.find(
      //     (type) => type.vehicleCapacityId === intValue12
      //   );

      //   setFormInput((prevData) => ({
      //     ...prevData,
      //     [name]: intValue12,
      //     vehicleCapacityName: selectedVehicleCapacity
      //       ? selectedVehicleCapacity.vehicleCapacityName
      //       : "",
      //   }));
      //   break;

      case "ownerTypeId":
        // If it's an owner type field, set the value and type name in the form input
        const intValue2 = parseInt(value, 10);
        const selectedOwnerType = ownerTypeDetails.find(
          (type) => type.ownerTypeId === intValue2
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue2,
          ownerTypeName: selectedOwnerType
            ? selectedOwnerType.ownerTypeName
            : "",
        }));
        break;

      case "loadingEquipmentNumber":
        // Ensure that only capital letters and numbers are allowed, no special characters
        const sanitizedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
        setFormInput((prevData) => ({
          ...prevData,
          [name]: sanitizedValue,
        }));
        break;

      case "loadingEquipmentUid":
        // Ensure that vehicle UUID doesn't contain small letters
        const sanitizedUUID1 = value
          .replace(/[^a-zA-Z0-9/]/g, "")
          .toUpperCase();
        setFormInput((prevData) => ({
          ...prevData,
          [name]: sanitizedUUID1,
        }));

        break;
      case "vehicleStatusId":
        // If it's an owner type field, set the value and type name in the form input

        if (name === "vehicleStatusId") {
          const intValue10 = parseInt(value, 10);
          const selectedVehicleStatus = vehicleStatusDetails.find(
            (capacity) => capacity.vehicleStatusId === intValue10
          );
          // Check if the selected value is 2 or 3
          if (value === "2" || value === "3") {
            // Set isActive to false if vehicleStatusId is 2 or 3
            setFormInput((prevData) => ({
              ...prevData,
              isActive: false,
              [name]: intValue10, // Update vehicleStatusId
              vehicleStatusName: selectedVehicleStatus
                ? selectedVehicleStatus.vehicleStatusName
                : "",
            }));
          } else {
            // Set isActive to true for other values of vehicleStatusId
            setFormInput((prevData) => ({
              ...prevData,
              isActive: true,
              [name]: intValue10, // Update vehicleStatusId
              vehicleStatusName: selectedVehicleStatus
                ? selectedVehicleStatus.vehicleStatusName
                : "",
            }));
          }
        }
        break;
      case "loadingEquipmentCode":
        // Allow only alphanumeric characters for the vehicle type code
        const sanitizedCode = value.replace(/[^a-zA-Z0-9-]/g, "").toUpperCase();
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedCode }));
        break;
      default:
        setFormInput((prevData) => ({ ...prevData, [name]: value }));
        break;
    }
  };

  useEffect(() => {
    if (!selectedZone) {
      // Clear circles and wards when zone is unselected
      setAllCircles([]);
      setAllWards([]);
    }
  }, [selectedZone]);

  const [allVehicleData, setAllVehicleData] = useState([]);

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const formattedDate = `${currentDate.getFullYear()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Loading Equipment Details`;
    const downloadDateTime = `Loading Equipment Report Generated on: ${generationTime},${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("LoadingEquipment");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add "Loading Equipment Details" to the correct row and columns
    worksheet.addRow(["", "", "Loading Equipment Details", ""]);
    worksheet.mergeCells(2, 2, 2, 8);
    worksheet.getCell(2, 2).value = "Loading Equipment Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Loading Equipment Number",
      "Loading Equipment UID",
      "OwnerType",
      "Vehicle Status",
      "Vehicle Type",
      "Vehicle Capacity",
      "Corporation",
      "Zone",
      "Circle",
      "Ward",
      "Shift A", // Added Shift A header
      "Shift B", // Added Shift B header
      "Shift C", // Added Shift C header
      "Loading Equipment Code", // Moved Loading Equipment Code after shift columns
      "Status", // Status column moved to the last
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 15) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    allVehicleData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.loadingEquipmentNumber,
          item.loadingEquipmentUid,
          item.ownerTypeName,
          item.vehicleStatusName,
          item.vehicleTypeName,
          item.vehicleCapacityName,
          item.corporationName || "N/A",
          item.zoneName,
          item.circleName,
          item.wardName,
          item.shiftA ? true : false, // Shift A data check
          item.shiftB ? true : false, // Shift B data check
          item.shiftC ? true : false, // Shift C data check
          item.loadingEquipmentCode,
          item.isActive ? "Active" : "InActive", // Status column moved to the last
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 9) {
            cell.alignment = { horizontal: "left" }; // Align the first columns to the left
          } else {
            cell.alignment = { horizontal: "left" }; // Align the shift and status columns to the center
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },  // S.No
      { width: 25 }, // Loading Equipment Number
      { width: 25 }, // Loading Equipment UID
      { width: 25 }, // OwnerType
      { width: 25 }, // Vehicle Status
      { width: 25 }, // Vehicle Type
      { width: 25 }, // Vehicle Capacity
      { width: 25 }, // Corporation
      { width: 25 }, // Zone
      { width: 25 }, // Circle
      { width: 25 }, // Ward
      { width: 15 }, // Shift A
      { width: 15 }, // Shift B
      { width: 15 }, // Shift C
      { width: 25 }, // Loading Equipment Code
      { width: 15 }, // Status
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "LoadingEquipmentDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  // Use this page's own permissionId so the Add/Update buttons don't depend on
  // the shared localStorage "permissionId" (which caused them to sometimes hide).
  storedPermissions = 8;

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    // console.log(
    //   `canWrite value for permission ID ${storedPermissions}:`,
    //   canWriteValue
    // );
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const fetchCirclesAndWards = async (zoneId) => {
    try {
      // Fetch circles for the selected zone
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
    } catch (error) {
      console.error("Error fetching circles data:", error);

      setAllCircles([]);
    }
  };

  // Update to use selectedZone instead of the hardcoded value
  useEffect(
    () => {
      if (selectedZone) {
        fetchCirclesAndWards(selectedZone);
      }
    },
    []
    //[selectedZone]
  );
  useEffect(() => {
    const fetchZoneData = async () => {
      try {
        // Fetch zone data from the API
        const zonesData = await GetZone();
        // Set the fetched zone data in the state variable
        setAllZones(zonesData);
      } catch (error) {
        console.error("Error fetching zone data:", error);
      }
    };

    // Call the fetchZoneData function
    fetchZoneData();
  }, []);

  const handleCircleChange = async (circleId) => {
    if (!circleId) {
      setAllWards([]);
      return;
    }

    try {
      // Fetch wards for the selected circle
      setLoadingWards(true);
      const wardsData = await GetWardsbyCircleId(circleId);
      setAllWards(wardsData);
    } catch (error) {
      console.error("Error fetching wards data:", error);
      setAllWards([]);
    } finally {
      setLoadingWards(false);
    }
  };

  const handleDownloadQRCode = async () => {
    const zip = new JSZip();
    const qrSize = 256;
    const promises = allVehicleData.map((vehicle, index) => {
      return new Promise((resolve, reject) => {
        const qrContent = vehicle.loadingEquipmentUid;

        // Create QR code
        const qr = new QRCode({
          content: qrContent || "",
          padding: 4,
          width: qrSize,
          height: qrSize,
          color: "#000000",
          background: "#ffffff",
          ecl: "M",
        });

        const svg = qr.svg();
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        const pdf = new jsPDF("p", "mm", "a4");
        pdf.setFont("helvetica", "bold");

        img.onload = () => {
          canvas.width = qrSize;
          canvas.height = qrSize;
          ctx.drawImage(img, 0, 0, qrSize, qrSize);

          const imgData = canvas.toDataURL("image/jpeg", 1.0);
          const scaleFactor = 0.5;
          const scaledWidth = qrSize * scaleFactor;
          const scaledHeight = qrSize * scaleFactor;

          const pageWidth = pdf.internal.pageSize.getWidth();
          const initialX = (pageWidth - scaledWidth) / 2;
          const initialY = 10;

          // Add QR Code to PDF
          pdf.addImage(
            imgData,
            "JPEG",
            initialX,
            initialY,
            scaledWidth,
            scaledHeight
          );

          // Equipment details
          const labels = [
            "OWNER TYPE",
            "VEHICLE TYPE",
            "LOADING EQUIPMENT.NO",
            "VEHICLE STATUS",
            "ZONE",
            "CIRCLE",
            "UID",
          ];
          const values = [
            vehicle.ownerTypeName,
            vehicle.vehicleTypeName,
            vehicle.loadingEquipmentNumber,
            vehicle.vehicleStatusName,
            vehicle.zoneName,
            vehicle.circleName,
            vehicle.loadingEquipmentUid,
            vehicle.loadingEquipmentCode,
          ];

          let maxLabelWidth = 0;
          labels.forEach((label) => {
            const labelWidth = pdf.getTextWidth(label);
            if (labelWidth > maxLabelWidth) {
              maxLabelWidth = labelWidth;
            }
          });

          const lineHeight = 7;
          const textX = 60; // Shift text further right
          let textY = initialY + scaledHeight + 10;

          pdf.setFont("arial", "normal");
          labels.forEach((label, i) => {
            pdf.text(label, textX, textY);
            pdf.text(": ", textX + maxLabelWidth + 5, textY); // Adjust spacing
            pdf.text(values[i] || "-", textX + maxLabelWidth + 15, textY); // Move values further right
            textY += lineHeight;
          });

          // Save the PDF into a Blob
          const pdfBlob = pdf.output("blob");

          // Add PDF file to the ZIP with a name reflecting table order
          zip.file(`${index + 1}_${vehicle.loadingEquipmentUid}.pdf`, pdfBlob);

          resolve();
        };

        img.onerror = reject;
        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
      });
    });

    try {
      await Promise.all(promises);
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "qrcodes.zip");
      console.log("ZIP file with PDFs generated and downloaded successfully.");
    } catch (error) {
      console.error("Error generating or downloading ZIP file:", error);
    }
  };

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...allVehicleData].sort((a, b) => {
      if (sortConfig.order === "asc") {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const searchLoadingEquipmentHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalLoadingEquipmentData.filter(
      (item) =>
        item?.loadingEquipmentNumber?.toLowerCase()?.includes(term) ||
        item?.loadingEquipmentUID?.toLowerCase()?.includes(term)
    );
    setAllVehicleData(data);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group mb-0">
                    <input
                      placeholder="Search Loading Equipment Number or UID"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchLoadingEquipmentHandler}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="flex_end_middle">
                    {canWriteValue === true ? (
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("Add Loading Equipment")}
                      </button>
                    ) : (
                      ""
                    )}
                    <button
                      className="btn btn-excel"
                      onClick={handleSortAndExport}
                    >
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Excel
                    </button>
                    <button
                      className="btn btn-excel"
                      onClick={handleDownloadQRCode}
                    >
                      <i class="fa-regular fa-file-pdf me-1 icon-container"></i>
                      Download QR
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span>{t("Loading Equipment Details")}</span>
                </div>
                <div className="table-responsive">
                  {isLoading?<TableSkeleton />: <TableComponent
                    DataFetchURL={allVehicleData}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 2
                      )
                    }
                    editData={handleEditVehicleData} // Pass the callback function
                    editDataDetails={editVehicleData}
                    // viewData={handleViewVehicleData}
                    onSort={handleSort}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editVehicleData
              ? t("Edit Loading Equipment")
              : t("Add Loading Equipment")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateVehicleDetails}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {"Corporation"}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={selectedCorporationId}
                    className={`form-select ${
                      selectedCorporationId || !formSubmitted ? "" : "input-error"
                    }`}
                    onChange={(e) => {
                      const corpId = e.target.value;
                      setSelectedCorporationId(corpId);
                      setFormInput((prev) => ({
                        ...prev,
                        zoneId: "",
                        zoneName: "",
                        circleId: "",
                        wardId: null,
                        circleName: "",
                        wardName: "",
                      }));
                      setAllCircles([]);
                      setAllWards([]);
                    }}
                  >
                    <option value="">Select Corporation</option>
                    {UserCorporations.map((cd) => (
                      <option key={cd.corporationId} value={cd.corporationId}>
                        {cd.corporationName}
                      </option>
                    ))}
                  </select>
                  {!selectedCorporationId && formSubmitted && (
                    <div className="required-message">Corporation is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {"Zone"}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.zoneId}
                    name="zoneId"
                    className={`form-select ${
                      formInput.zoneId || !formSubmitted ? "" : "input-error"
                    }`}
                    onChange={(e) => {
                      const selectedZoneId = e.target.value;
                      setSelectedZone(selectedZoneId);
                      
                      const selectedZone = selectedZoneId
                        ? allZones.find(
                            (zone) => zone.zoneId === parseInt(selectedZoneId) || zone.zoneId === selectedZoneId
                          )
                        : null;

                      if (selectedZoneId) {
                        // Fetch circles for the selected zone
                        fetchCirclesAndWards(selectedZoneId);
                      } else {
                        // Clear circles and wards when zone is unselected
                        setAllCircles([]);
                        setAllWards([]);
                      }

                      // Update formInput with the selected zoneId
                      setFormInput({
                        ...formInput,
                        zoneId: selectedZoneId,
                        zoneName: selectedZone ? selectedZone.zoneName : "",
                        circleId: "", // Reset circleId when zone changes
                        wardId: null, // Reset wardId when zone changes
                        circleName: "", // Clear circle name
                        wardName: "", // Clear ward name
                      });
                    }}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {allZones
                      .filter((zone) => zone.isActive && (!selectedCorporationId || String(zone.corporationId) === String(selectedCorporationId)))
                      .map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message"> Zone is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {"Circle"} <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.circleId}
                    name="circleId"
                    className="form-select"
                    // className={`form-select ${formInput.circleId || !formSubmitted ? "" : "input-error"
                    //   }`}
                    onChange={(e) => {
                      const selectedCircleId = e.target.value;
                      const selectedCircle = selectedCircleId 
                        ? allCircles.find(
                            (circle) => circle.circleId === parseInt(selectedCircleId) || circle.circleId === selectedCircleId
                          )
                        : null;
                      
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: selectedCircleId,
                        circleName: selectedCircle ? selectedCircle.circleName : "",
                        wardId: null, // Reset ward when circle changes
                        wardName: "", // Clear ward name
                      }));
                      
                      if (selectedCircleId) {
                        handleCircleChange(selectedCircleId); // Fetch wards for the selected circle
                      } else {
                        // Clear wards when circle is unselected
                        setAllWards([]);
                      }
                    }}
                    disabled={!formInput.zoneId || !canWriteValue}
                  >
                    <option value="">Select</option>
                    {formInput.zoneId && Array.isArray(allCircles) &&
                      allCircles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))}
                  </select>
                  {!formInput.circleId && formSubmitted && (
                    <div className="required-message"> Circle is Required</div>
                  )}
                </div>
                {/* )} */}
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {"Ward"}
                    {""}
                    {/* <span style={{ color: "#EC1117" }}> *</span> */}
                  </label>
                  <select
                    value={formInput.wardId || ""}
                    name="wardId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedWardId = e.target.value;
                      const selectedWard = selectedWardId
                        ? allWards.find(
                            (ward) => ward.wardId === parseInt(selectedWardId) || ward.wardId === selectedWardId
                          )
                        : null;
                      
                      setFormInput((prevData) => ({
                        ...prevData,
                        wardId: selectedWardId || null,
                        wardName: selectedWard ? selectedWard.wardName : "",
                      }));
                    }}
                    disabled={!formInput.circleId || !canWriteValue}
                  >
                    <option value="">Select</option>
                    {loadingWards && <option disabled>Loading Wards...</option>}
                    {formInput.circleId && Array.isArray(allWards) &&
                      allWards.map((ward) => (
                        <option key={ward.wardId} value={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))}
                  </select>
                  {/* {!formInput.wardId && formSubmitted && (
                    <div className="required-message"> Ward is Required</div>
                  )} */}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Loading Equipment Code")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="loadingEquipmentCode"
                    value={formInput.loadingEquipmentCode}
                    className={`form-control ${
                      formInput.loadingEquipmentCode || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    placeholder="Enter LoadingEquipment Code"
                    onChange={handleInputChange}
                    maxLength={50}
                    disabled={!canWriteValue}
                  />
                  {!formInput.loadingEquipmentCode && formSubmitted && (
                    <div className="required-message">
                      Loading Equipment Code is Required
                    </div>
                  )}
                </div>
              </div>
              {/* Vehicle Type */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">{t("vehicle_type")} </label>
                  <span style={{ color: "#EC1117" }}> *</span>
                  <select
                    className={`form-select ${
                      formInput.vehicleTypeId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    // className="form-select"
                    value={formInput.vehicleTypeId}
                    onChange={(e) => {
                      handleInputChange(e);
                      if (e.target.value === "") {
                        setFormInput({
                          ...formInput,
                          vehicleTypeId: "",
                          vehicleCapacityId: "",
                        });
                      }
                    }}
                    id="vehcileTypeId"
                    name="vehicleTypeId"
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {vehicleTypeDetails
                      .filter((vehicleType) => vehicleType.isActive) // Filter active options
                      .map((vehicleType) => (
                        <option
                          key={vehicleType.vehicleTypeId}
                          value={vehicleType.vehicleTypeId}
                        >
                          {vehicleType.vehicleTypeName}
                        </option>
                      ))}
                  </select>

                  {!formInput.vehicleTypeId && formSubmitted && (
                    <div className="required-message">
                      Vehicle Type is Required
                    </div>
                  )}
                </div>
              </div>

              {/* Vehicle Capacity */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">{t("Vehicle Capacity")} </label>
                  <span style={{ color: "#EC1117" }}> *</span>
                  <select
                    value={formInput.vehicleCapacityId}
                    onChange={handleInputChange}
                    id="vehicleCapacityId"
                    name="vehicleCapacityId"
                    disabled={formInput.vehicleTypeId === ""}
                    className={`form-select ${
                      formInput.vehicleCapacityId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                  >
                    <option value="">Select</option>
                    {vehicleCapacityDetails
                      .filter(
                        (vehicleCapacity) =>
                          vehicleCapacity.isActive &&
                          formInput.vehicleTypeId ==
                            vehicleCapacity.vehicleTypeId
                      )
                      .map((vehicleCapacity) => (
                        <option
                          key={vehicleCapacity.vehicleCapacityId}
                          value={vehicleCapacity.vehicleCapacityId}
                        >
                          {vehicleCapacity.vehicleCapacityName}
                        </option>
                      ))}
                  </select>
                  {!formInput.vehicleCapacityId && formSubmitted && (
                    <div className="required-message">
                      Vehicle Capacity is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label htmlFor="vehicleStatus">{"Vehicle Status"}</label>
                  <span style={{ color: "#EC1117" }}> *</span>
                  <select
                    className={`form-select ${
                      formInput.vehicleStatusId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    // className="form-select"
                    id="vehicleStatusName"
                    name="vehicleStatusId"
                    value={formInput.vehicleStatusId}
                    onChange={handleInputChange}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {vehicleStatusDetails.map((vehicleStatus) => (
                      <option
                        key={vehicleStatus.vehicleStatusId}
                        value={vehicleStatus.vehicleStatusId}
                      >
                        {vehicleStatus.vehicleStatusName}
                      </option>
                    ))}
                  </select>
                  {!formInput.vehicleStatusName && formSubmitted && (
                    <div className="required-message">
                      Vehicle Status is Required
                    </div>
                  )}
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <div class="form-group">
                  <label class="form-label">{t("ownerType")} </label>
                  <span style={{ color: "#EC1117" }}> *</span>
                  <select
                    // className={`form-select ${
                    //   formInput.ownerTypeId || !formSubmitted
                    //     ? ""
                    //     : "input-error"
                    // }`}
                    className="form-select"
                    id="ownerTypeId"
                    name="ownerTypeId"
                    value={formInput.ownerTypeId}
                    onChange={handleInputChange}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {ownerTypeDetails
                      .filter((ownerType) => ownerType.isActive)
                      .map((ownerType) => (
                        <option
                          key={ownerType.ownerTypeId}
                          value={ownerType.ownerTypeId}
                        >
                          {ownerType.ownerTypeName}
                        </option>
                      ))}
                  </select>
                  {!formInput.ownerTypeId && formSubmitted && (
                    <div className="required-message">
                      Owner Type is required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Loading Equipment Number")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="loadingEquipmentNumber"
                    value={formInput.loadingEquipmentNumber}
                    className={`form-control ${
                      formInput.loadingEquipmentNumber || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    placeholder="Enter Loading Equipment Number"
                    maxLength={12}
                    onChange={handleInputChange}
                    disabled={!canWriteValue}
                  />
                  {!formInput.loadingEquipmentNumber && formSubmitted && (
                    <div className="required-message">
                      Loading Equipment Number is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Loading Equipment UID")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="loadingEquipmentUid"
                    value={formInput.loadingEquipmentUid}
                    className={`form-control ${
                      formInput.loadingEquipmentUid || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    placeholder="Enter Loading Equipment UID"
                    maxLength={24}
                    onChange={handleInputChange}
                    // readOnly={!!editVehicleData}
                    disabled={!canWriteValue}
                  />
                  {!formInput.loadingEquipmentUid && formSubmitted && (
                    <div className="required-message">
                      Loading Equipment UID is Required
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ marginTop: "5px" }}>
              <label className="form-label">
                {t("status")}
                <span style={{ color: "#EC1117" }}> *</span>
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    checked={formInput.isActive} // Check if isActive is true
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: true }, // Set value to true
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    checked={formInput.isActive === false}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: false }, // Set value to false
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ marginTop: "5px" }}>
              <label className="form-label">
                {t("Shift")}
                <span style={{ color: "#EC1117" }}> *</span>
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="ShiftA"
                    id="morning"
                    checked={formInput.ShiftA || false} // Check if isActive is true
                    onChange={() =>
                      handleInputChange({
                        target: { name: "ShiftA", value: !formInput.ShiftA },
                        // target: { name: "ShiftA",  value: formInput.ShiftA === true ? false : true, }, // Set value to true
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="activeRadio">
                    A
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="ShiftB"
                    id="afternoon"
                    checked={formInput.ShiftB || false}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "ShiftB", value: !formInput.ShiftB },
                        // target: { name: "ShiftB",  value: formInput.ShiftB === true ? false : true, }, // Set value to false
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    B
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="ShiftC"
                    id="evening"
                    checked={formInput.ShiftC || false}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "ShiftC", value: !formInput.ShiftC },
                        // target: { name: "ShiftC", value: formInput.ShiftC === true ? false : TroubleshootOutlined, }, // Set value to false
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    C
                  </label>
                </div>
              </div>
              {!formInput.ShiftA &&
                !formInput.ShiftB &&
                !formInput.ShiftC &&
                formSubmitted && (
                  <div className="required-message" style={{ color: "red" }}>
                    At least one shift must be selected
                  </div>
                )}
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ? (
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {editVehicleData ? t("Update") : t("Save")}
                </button>
              ) : (
                ""
              )}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(LoadingEquipment);
